"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetContractInvoicing = class FieldsetContractInvoicing extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    updateBillingCycle(...args) {
        this.contract.invoicing.billing_cycle = `${this.billing_frequency.value} ${this.billing_frequency.unit}`;
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    billing_frequency;
    async $$load_billing_frequency() {
        return this.contract.invoicing.billing_cycle != null ?
            {
                value: this.contract.invoicing.billing_cycle.split(" ")[0],
                unit: this.contract.invoicing.billing_cycle.split(" ")[1]
            } : {
            value: null,
            unit: null
        };
    }
    billingFrequencyOptions;
    contractPaymentTermTypes;
    async $$load_contractPaymentTermTypes() {
        return this.$fn.getEnumValuesFromSchema('ContractPaymentTermTypes');
    }
    ux;
    dataMembers = ['currencies', 'billing_frequency', 'billingFrequencyOptions', 'contractPaymentTermTypes', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                currencies: null,
                billing_frequency: null,
                billingFrequencyOptions: [{
                        value: "day",
                        text: this.$fn.gettext("day"),
                    },
                    {
                        value: "month",
                        text: this.$fn.gettext("month"),
                    },
                ],
                contractPaymentTermTypes: null,
                ux: null,
            },
        };
    }
    async act_1485536987289644_script_8820_getActionArgs_value($event) {
        this.updateBillingCycle();
    }
    async act_1485536987289644_script_8820_getActionArgs($event) {
        return {
            value: () => this.act_1485536987289644_script_8820_getActionArgs_value($event),
        };
    }
    async evh_1485536987289644_input(event, scope) {
        return await this.actions.evh_1485536987289644_input.executeFromDOM(this, event, scope);
    }
    async act_6414008351552349_script_8822_getActionArgs_value($event) {
        this.updateBillingCycle();
    }
    async act_6414008351552349_script_8822_getActionArgs($event) {
        return {
            value: () => this.act_6414008351552349_script_8822_getActionArgs_value($event),
        };
    }
    async evh_6414008351552349_input(event, scope) {
        return await this.actions.evh_6414008351552349_input.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1485536987289644_script_8820 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1485536987289644_script_8820_getActionArgs,
            events: [],
        });
        const evh_1485536987289644_input_8819 = new core_1.actions.EventHandlerImpl({
            action: act_1485536987289644_script_8820,
            event: "input",
            displayName: "script",
        });
        const evh_1485536987289644_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1485536987289644_input_8819],
        });
        const act_6414008351552349_script_8822 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6414008351552349_script_8822_getActionArgs,
            events: [],
        });
        const evh_6414008351552349_input_8821 = new core_1.actions.EventHandlerImpl({
            action: act_6414008351552349_script_8822,
            event: "input",
            displayName: "script",
        });
        const evh_6414008351552349_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6414008351552349_input_8821],
        });
        return {
            act_1485536987289644_script_8820,
            evh_1485536987289644_input_8819,
            evh_1485536987289644_input,
            act_6414008351552349_script_8822,
            evh_6414008351552349_input_8821,
            evh_6414008351552349_input,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetContractInvoicing.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractInvoicing.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetContractInvoicing.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractInvoicing.prototype, "onLabel_align", null);
FieldsetContractInvoicing = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetContractInvoicing);
exports.default = FieldsetContractInvoicing;
vue_property_decorator_1.Vue.component("FieldsetContractInvoicing", FieldsetContractInvoicing);
